var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-color/~/lodash/_Symbol.js
 ** module id = 1479
 ** module chunks = 0
 **/